export default __webpack_public_path__ + "static/media/spider.ba3d8efe.png";